/**
 * STITCH SOAP — Theme JavaScript
 * Handles: Cart drawer, mobile nav, product filter, qty controls, form submission
 */

// ── CART STATE ──────────────────────────────────────────────
let cart = JSON.parse(localStorage.getItem('stitch_cart') || '[]');

function saveCart() {
  localStorage.setItem('stitch_cart', JSON.stringify(cart));
  updateCartCount();
  renderCartItems();
}

function updateCartCount() {
  const total = cart.reduce((s, i) => s + i.qty, 0);
  document.querySelectorAll('.cart-count').forEach(el => {
    el.textContent = total;
    el.style.display = total > 0 ? 'flex' : 'none';
  });
}

function addToCart(id, title, price, image, number) {
  const existing = cart.find(i => i.id === id);
  if (existing) {
    existing.qty++;
  } else {
    cart.push({ id, title, price, image, number, qty: 1 });
  }
  saveCart();
  openCart();
  showToast(`${title} added to cart`);
}

function removeFromCart(id) {
  cart = cart.filter(i => i.id !== id);
  saveCart();
}

function updateQty(id, delta) {
  const item = cart.find(i => i.id === id);
  if (!item) return;
  item.qty = Math.max(1, item.qty + delta);
  saveCart();
}

function clearCart() {
  cart = [];
  saveCart();
}

function getSubtotal() {
  return cart.reduce((s, i) => s + i.price * i.qty, 0);
}

function renderCartItems() {
  const body = document.querySelector('.cart-drawer__body');
  const footer = document.querySelector('.cart-drawer__footer');
  if (!body) return;

  if (cart.length === 0) {
    body.innerHTML = `
      <div class="cart-empty">
        <img src="${window.STITCH_ASSETS?.skullMale || ''}" alt="" class="cart-empty__icon">
        <div class="cart-empty__text">
          <strong>Your cart is empty.</strong><br>
          The right bar is out there.
        </div>
        <a href="/collections/all" class="btn btn-primary" style="font-size:0.7rem">Shop the Collection</a>
      </div>`;
    if (footer) footer.innerHTML = '';
    return;
  }

  body.innerHTML = cart.map(item => `
    <div class="cart-item" data-id="${item.id}">
      <div class="cart-item__image">
        <img src="${item.image}" alt="${item.title}" loading="lazy">
      </div>
      <div class="cart-item__info">
        <div class="cart-item__number">No. ${item.number}</div>
        <div class="cart-item__name">${item.title}</div>
        <div class="cart-item__controls">
          <div class="qty-control">
            <button class="qty-btn" onclick="updateQty('${item.id}', -1)" aria-label="Decrease">−</button>
            <span class="qty-display">${item.qty}</span>
            <button class="qty-btn" onclick="updateQty('${item.id}', 1)" aria-label="Increase">+</button>
          </div>
          <span class="cart-item__price">$${(item.price * item.qty).toFixed(2)}</span>
        </div>
        <button class="cart-remove" onclick="removeFromCart('${item.id}')">Remove</button>
      </div>
    </div>
  `).join('');

  if (footer) {
    footer.innerHTML = `
      <div class="cart-subtotal">
        <span class="cart-subtotal__label">Subtotal</span>
        <span class="cart-subtotal__amount">$${getSubtotal().toFixed(2)}</span>
      </div>
      <a href="/cart" class="btn btn-primary cart-checkout">Proceed to Checkout</a>
      <button class="cart-clear" onclick="clearCart()">Clear cart</button>`;
  }
}

// ── CART DRAWER OPEN/CLOSE ──────────────────────────────────
function openCart() {
  document.querySelector('.cart-drawer')?.classList.add('is-open');
  document.querySelector('.cart-overlay')?.classList.add('is-open');
  document.body.style.overflow = 'hidden';
}

function closeCart() {
  document.querySelector('.cart-drawer')?.classList.remove('is-open');
  document.querySelector('.cart-overlay')?.classList.remove('is-open');
  document.body.style.overflow = '';
}

// ── MOBILE NAV ──────────────────────────────────────────────
function toggleMobileNav() {
  const nav = document.querySelector('.mobile-nav');
  nav?.classList.toggle('is-open');
}

// ── TOAST ───────────────────────────────────────────────────
function showToast(message) {
  let container = document.querySelector('.toast-container');
  if (!container) {
    container = document.createElement('div');
    container.className = 'toast-container';
    document.body.appendChild(container);
  }
  const toast = document.createElement('div');
  toast.className = 'toast';
  toast.textContent = message;
  container.appendChild(toast);
  setTimeout(() => toast.remove(), 3500);
}

// ── PRODUCT FILTER (Collection pages) ──────────────────────
function initProductFilter() {
  const tabs = document.querySelectorAll('.filter-tab[data-filter]');
  if (!tabs.length) return;

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');

      const filter = tab.dataset.filter;
      document.querySelectorAll('.product-card-wrap').forEach(card => {
        const gender = card.dataset.gender;
        const category = card.dataset.category;
        const genderMatch = filter === 'all' || filter === 'his' || filter === 'hers' || filter === 'unisex'
          ? (filter === 'all' || gender === filter)
          : true;
        const catMatch = filter === 'soap' || filter === 'shampoo'
          ? category === filter
          : true;
        card.style.display = (genderMatch && catMatch) ? '' : 'none';
      });
    });
  });
}

// ── QTY SELECTOR (Product detail page) ─────────────────────
function initQtySelector() {
  const selector = document.querySelector('.qty-selector');
  if (!selector) return;

  const display = selector.querySelector('.qty-selector__display');
  const dec = selector.querySelector('[data-qty-dec]');
  const inc = selector.querySelector('[data-qty-inc]');
  let qty = 1;

  dec?.addEventListener('click', () => {
    qty = Math.max(1, qty - 1);
    if (display) display.textContent = qty;
  });
  inc?.addEventListener('click', () => {
    qty++;
    if (display) display.textContent = qty;
  });

  document.querySelector('.add-to-cart-btn')?.addEventListener('click', () => {
    const btn = document.querySelector('.add-to-cart-btn');
    if (!btn) return;
    const id = btn.dataset.productId;
    const title = btn.dataset.productTitle;
    const price = parseFloat(btn.dataset.productPrice);
    const image = btn.dataset.productImage;
    const number = btn.dataset.productNumber;
    for (let i = 0; i < qty; i++) addToCart(id, title, price, image, number);
  });
}

// ── INGREDIENT SEARCH ───────────────────────────────────────
function initIngredientSearch() {
  const input = document.querySelector('.ingredient-search');
  if (!input) return;

  input.addEventListener('input', () => {
    const q = input.value.toLowerCase();
    document.querySelectorAll('.ingredient-entry').forEach(entry => {
      const text = entry.textContent.toLowerCase();
      entry.style.display = text.includes(q) ? '' : 'none';
    });
  });
}

// ── CONTACT FORM ────────────────────────────────────────────
function initContactForm() {
  const form = document.querySelector('.contact-form');
  if (!form) return;

  form.addEventListener('submit', e => {
    e.preventDefault();
    const name = form.querySelector('[name="contact[name]"]')?.value;
    const email = form.querySelector('[name="contact[email]"]')?.value;
    const message = form.querySelector('[name="contact[body]"]')?.value;

    if (!name || !email || !message) {
      showToast('Please fill in all required fields.');
      return;
    }

    // In real Shopify, this form submits to /contact
    form.closest('.contact-form-wrap')?.classList.add('is-submitted');
    showToast('Message sent! We\'ll get back to you soon.');
  });
}

// ── INIT ────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  updateCartCount();
  renderCartItems();
  initProductFilter();
  initQtySelector();
  initIngredientSearch();
  initContactForm();

  // Cart toggle
  document.querySelector('.cart-toggle-btn')?.addEventListener('click', openCart);
  document.querySelector('.cart-close-btn')?.addEventListener('click', closeCart);
  document.querySelector('.cart-overlay')?.addEventListener('click', closeCart);

  // Mobile nav
  document.querySelector('.mobile-nav-toggle')?.addEventListener('click', toggleMobileNav);

  // Add to cart buttons on collection pages
  document.querySelectorAll('.product-card__add').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const id = btn.dataset.productId;
      const title = btn.dataset.productTitle;
      const price = parseFloat(btn.dataset.productPrice);
      const image = btn.dataset.productImage;
      const number = btn.dataset.productNumber;
      addToCart(id, title, price, image, number);
    });
  });
});
